import { forwardRef, useCallback } from 'react';
import cn from 'clsx';
import { AnimatedCoinRive } from "../../AnimatedCoinRive";
import { AnimatedStaticCoinRive } from "../../AnimatedStaticCoinRive";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RewardRightSide = /*#__PURE__*/forwardRef(function (props, ref) {
  var _AnimatedStaticCoinRi, _AnimatedCoinRive;
  var isPlaying = props.isPlaying,
    isStaticAnimation = props.isStaticAnimation,
    style = props.style,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    className = props.className,
    coins = props.coins,
    rewardName = props.rewardName;
  var renderAnimatedCoin = useCallback(function () {
    return isStaticAnimation ? _AnimatedStaticCoinRi || (_AnimatedStaticCoinRi = /*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
      startAnimation: isPlaying
    })) : _AnimatedCoinRive || (_AnimatedCoinRive = /*#__PURE__*/_jsx(AnimatedCoinRive, {
      startAnimation: isPlaying
    }));
  }, [isPlaying, isStaticAnimation]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-flex tw-h-2.4 tw-max-h-2.4', isStaticAnimation ? 'tw-items-center' : 'tw-items-end'),
    ref: ref,
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-testid": props.dataTestId,
    children: [renderAnimatedCoin(), /*#__PURE__*/_jsxs("p", {
      className: cn('tw-ml-0.4 tw-font-subtitle4 tw-text-warning-400 tw-line-clamp-1', className),
      children: [coins, " ", rewardName]
    })]
  });
});
RewardRightSide.displayName = 'RewardRightSide';
export default RewardRightSide;